import { Progress } from "@chakra-ui/react";
import zxcvbn from "zxcvbn";

export default function CheckPasswordProgressBar({ pwd }: any) {
  const testResult = zxcvbn(pwd.new);
  const num = (testResult.score * 100) / 4;

  function getColor(num: number) {
    if (num <= 20) {
      return "red";
    } else if (num <= 40) {
      return "orange";
    } else if (num <= 60) {
      return "yellow";
    } else if (num <= 80) {
      return "green";
    } else {
      return "blue";
    }
  }

  return <Progress value={num} colorScheme={getColor(num)} />;
}
